// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_FETCH_TRANSACTION,
    API_INITIATE_REFUND,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import * as refundActions from './refund.actions';

// Constants
import {
    FETCH_REFUND_REQUEST,
    INITIATE_REFUND_REQUEST,
} from './refund.constants';
import moment from 'moment';
import { takeLatest, put, call } from 'redux-saga/effects';

const getRequestData = payload => {
    const request = {
        pageNo: payload.pageIndex || 1,
        pageSize: payload.pageSize || 10,
        transactionStates: ['SUCCESS'],
        transactionView: 'REFUND',
    };
    if (payload.createdOn) {
        request.startDateTime = moment(payload.createdOn.startDate)
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
        request.endDateTime = moment(payload.createdOn.endDate)
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');
    }
    if (payload.isLive !== undefined) {
        request.isLive = payload.isLive;
    }
    if (payload.merchantId) {
        request.merchantIds = [payload.merchantId];
    }
    if (payload.orderId) {
        request.orderId = payload.orderId;
    }
    if (payload.searchKey) {
        request.searchKey = payload.searchKey;
    }
    if (payload.searchValue) {
        request.searchValue = payload.searchValue;
    }
    return request;
};

export function* fetchRefundDetails(actions) {
    yield put(refundActions.showLoader());
    try {
        const { payload } = actions;
        const request = getRequestData(payload);
        const { data } = yield call(POST, API_FETCH_TRANSACTION, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(refundActions.fetchRefundSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                refundActions.fetchRefundError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(refundActions.fetchRefundError({ error: data }));
    }
    yield put(refundActions.hideLoader());
}

export function* initiateRefundDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_INITIATE_REFUND, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(refundActions.initiateRefundSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                refundActions.initiateRefundError({
                    message: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            refundActions.initiateRefundError({ message: data.errorMessage })
        );
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* refundSaga() {
    yield takeLatest(FETCH_REFUND_REQUEST, fetchRefundDetails);
    yield takeLatest(INITIATE_REFUND_REQUEST, initiateRefundDetails);
}
